module.exports = __webpack_public_path__ + "assets/delete.785480c8.svg";